/*******************************************************************************
  설  명 : 홈페이지 > 게시판 > 상세보기
  작성자 : 송영석
  작성일 : 2020-06-05
*******************************************************************************/
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from '@app/service/util.service';
import { BehaviorSubject } from 'rxjs';

import { HMemberService } from '@home/service/member.service';
import { BoardService } from '@app/home/service/board.service';

import { CommonService } from '@app/service/common.service';
import { Globals } from '@app/service/globals.service';
import { config } from '@app/service/config.service';

import { ToastrService } from 'ngx-toastr';
import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';
import { Meta } from '@angular/platform-browser';

/* 페이스북 API */
declare var FB: any;

@Component({
  selector: 'app-board-view',
  templateUrl: './board-view.component.html',
  styleUrls: ['./board-view.component.scss']
})
export class BoardViewComponent extends O2OZCMS implements OnInit, AfterViewInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public baseURL = config.baseUrl;

  public data: any = {
    detail: {contents:'', subject:''},
    upload: []
  };

  public params: any = {
    type: 'view',
    board_id: 'notice',
    group_id: '',
    row: 15,
    no: 1,
    group: 'subject',
    text: '',
    board_seq: ''
  };

  public boardInfo: any = {};
  public memberInfo: any = {};

  private twitter: any;
  public currentURL = encodeURIComponent(window.location.href);

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    public utilService: UtilService,
    private memberService: HMemberService,
    private boardService: BoardService,
    public globals: Globals,
    private meta: Meta,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
    // this.facebookSDKInit();
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.params.board_id = ( typeof params.board_id == 'undefined' || params.board_id == '' ) ? 'notice' : params.board_id;
      this.params.board_seq = ( typeof params.board_seq == 'undefined' || params.board_seq == '' ) ? '0' : params.board_seq;
      this.params.group_id = ( typeof params.group_id == 'undefined' || params.group_id == '' ) ? '' : params.group_id;
      this.params.type = ( typeof params.type == 'undefined' || params.type == '' ) ? 'view' : params.type;
      this.params.row = ( typeof params.row == 'undefined' || params.row == '' ) ? '10' : params.row;
      this.params.no = ( typeof params.no == 'undefined' || params.no == '' ) ? '1' : params.no;
      this.params.group = ( typeof params.group == 'undefined' || params.group == '' ) ? '' : params.group;
      this.params.text = ( typeof params.text == 'undefined' || params.text == '' ) ? '' : params.text;
      this.params.view_type = ( typeof params.view_type == 'undefined' || params.view_type == '' ) ? 'list' : params.view_type;
      this.params.totalCount = ( typeof params.totalCount == 'undefined' || params.totalCount == '' ) ? '0' : params.totalCount;      
      this.params.language = ( typeof params.language == 'undefined' || params.language == '' ) ? 'ko' : params.language;

      this.memberInfo$.subscribe( data => {
        if ( typeof data['memNo'] == 'undefined' )  {
          return false;
        } else {
          this.memberInfo = data;
        }
      });
      this.getBoardInfo( this.params.board_id );
    });
  }

  /*******************************************************************************
    설  명 : 뷰 처리 완료 후
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngAfterViewInit() {
    // indicator 표시 숨김
    setTimeout (() => {
      this.globals.indicator.next(true);
    });
  }

  /*******************************************************************************
    설  명 : 목록으로
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  list() {
    this.params.board_seq = '';
    this.params.type = 'list';

    this.router.navigate(
    ['/board/list'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  async getBoardInfo( board_id: any ) {
    await this.boardService.getBoardInfoId( this.params.board_id ).then( response => {
      if( response.ResultCode ) {
        this.boardInfo = response.data;

        // 게시글 정보 가져오기
        this.getBoardView( this.params );

      } else {
        // indicator 표시 숨김
        this.globals.indicator.next(false);

        this.toastrService.error( response.ResultMessage, "게시판 에러" );

        this.router.navigate( ['/main'] );
        return false;
      }
    }, error => {
      this.globals.indicator.next(false);
      console.log( error );

      this.toastrService.error( "존재하지 않는 게시판입니다.", "게시판 에러" );
    });
  }

  /*******************************************************************************
    설  명 : 게시글 읽기 권한 확인
    입력값 : 없음
    리턴값 : boolean
  *******************************************************************************/
  authViewCheck( writer ) {
    // AHRI 문의게시판, 특허/인증 기술행정 서비스문의
    if (this.boardInfo.board_type_code === '2000' || this.boardInfo.board_type_code === '2001') {
      const isAuth = (this.memberInfo.level >= 80 || this.memberInfo.level === '4'
        || this.memberInfo.memNo === writer) ? true : false;
      if (!isAuth) {
        this.toastrService.error( '문의 글은 관리자와 작성자만 확인 할 수 있습니다.' );
        this.list();
      }
    }
  }

  /*******************************************************************************
    설  명 : 수정/삭제 권한 확인
    입력값 : 없음
    리턴값 : boolean
  *******************************************************************************/
  authEditCheck( writer ) {
    const isAuth = (this.memberInfo.level >= 80 || this.memberInfo.memNo === writer) ? true : false;
    if (isAuth) {
      return true;
    }
    return false;
  }

  /*******************************************************************************
    설  명 : 답변쓰기 권한 확인 (관리자, 자문위원)
    입력값 : 없음
    리턴값 : boolean
  *******************************************************************************/
  authReplyCheck() {
    if (this.boardInfo.board_type_code === '2000' || this.boardInfo.board_type_code === '2001') {
      if (this.memberInfo.consultant !== null) {
        return true;
      }
    }
    return false;
  }

  /*******************************************************************************
    설  명 : 게시글 내용 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardView( params ) {
    this.boardService.getBoardView( params.board_id, params.board_seq, true ).then( response => {
      if( response.ResultCode ) {
        let tmp = {
          detail: response.data,
          upload: response.upload
        };

        this.authViewCheck(tmp.detail.writer);
        this.data = tmp;

        this.updateMetaTag();
        this.globals.indicator.next(false);
      } else {
        console.log( response );
        this.globals.indicator.next(false);
        this.toastrService.error( response.ResultMessage, "게시글 에러" );

        this.router.navigate( ['/main'] );
        return false;
      }
    }, error => {
      this.globals.indicator.next(false);
      console.log( error );

      this.toastrService.error( "존재하지 않는 게시글입니다.", "게시글 에러" );
    });
  }

  /*******************************************************************************
    설  명 : 수정
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  modify() {
    this.params.type = 'modify';

    this.router.navigate(
    ['/board/list'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 삭제
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  deletePost() {
    if ( confirm('게시글을 삭제하시겠습니까?') ) {
      this.boardService.deleteBoard( this.boardInfo.board_id, this.params.board_seq ).then( response => {
        if( response.ResultCode ) {
          this.toastrService.success( response.ResultMessage, '게시글 삭제' );
          this.list();
        } else {
          this.toastrService.error( response.ResultMessage, '게시글 삭제' );
        }
      });
    }
  }

  /*******************************************************************************
    설  명 : 답글쓰기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  reply() {
    this.params.type = 'reply';

    this.router.navigate(
    ['/board/list'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 서브메뉴 링크
    입력값 : item = 메뉴 array
    리턴값 : 없음
  *******************************************************************************/
  goLink( menu ) {
    let href = menu.link_url;
    let boardId = menu.board_id;
    let menuIndex = menu.seq;

    if (href === '') {
      let result = false;
      const link = function getURL(item) {
        if (item.link_url === '' && item.board_id === '') {
          for (const element of item.children) {
            getURL(element);
            if (result) {
              return false;
            }
          }
        } else {
          href = item.link_url;
          boardId = item.board_id;
          menuIndex = item.seq;
          result = true;
        }
      };
      link(menu);
    }

    if ( boardId === '' ) {
      this.router.navigate([ href ], { queryParams: { menu_seq: menuIndex }});
    } else {
      this.router.navigate([ (href !== '' ? href : '/board/list') ], { queryParams: { board_id: boardId } });
    }
  }

  /*******************************************************************************
    설  명 : 페이스북 SDK 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  facebookSDKInit() {
    (window as any).fbAsyncInit = function() {
      FB.init({
        appId      : '913324192488005',
        cookie     : true,
        xfbml      : true,
        version    : 'v3.1'
      });
      FB.AppEvents.logPageView();
    };

    (function(d, s, id) {
       var js, fjs = d.getElementsByTagName(s)[0];
       if (d.getElementById(id)) {
         return;
      }
       js = d.createElement(s); js.id = id;
       js.src = 'https://connect.facebook.net/ko_KR/sdk.js';
       fjs.parentNode.insertBefore(js, fjs);
     }(document, 'script', 'facebook-jssdk'));
  }

  /*******************************************************************************
    설  명 : MetaTag 업데이트
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  updateMetaTag() {
    this.meta.updateTag({ property: 'og:url', content: window.location.origin + this.router.url });
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:title', content: this.boardInfo.board_name });
    this.meta.updateTag({ property: 'og:description', content: this.data.detail.subject });
  }

  /*******************************************************************************
    설  명 : 페이스북 로그인
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  facebookLogin() {
    FB.login((response) => {
        if (response.authResponse) {
          // login success
          // login success code here
          // redirect to home page
          this.facebookShare();
        } else {
          console.log('User login failed');
        }
    });
  }

  /*******************************************************************************
    설  명 : 페이스북 게시글 공유
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  facebookShare() {
    // const url = window.location.origin + this.router.url;
    // // const url = 'http://www.ref.or.kr' + this.router.url;
    // this.meta.updateTag( { property: 'og:url', content: url }, `property='og:url'` );
    // this.meta.updateTag( { property: 'og:type', content: 'article' }, `property='og:type'` );
    // this.meta.updateTag( { property: 'og:title', content: this.boardInfo.board_name }, `property='og:title'` );
    // this.meta.updateTag( { property: 'og:description', content: this.data.detail.subject }, `property='og:description'` );
    // this.meta.updateTag( { property: 'og:image', content: 'http://ref.or.kr/assets/images/logo.png' }, `property='og:image'` );

    // FB.ui({
    //   method: 'share',
    //   href: url,
    //   }, function(response) {
    //     if (response && !response.error_message) {
    //       console.log('successfully posted');
    //     } else {
    //       console.log('Error while posting.');
    //     }
    // });

    window.open('https://www.facebook.com/sharer/sharer.php'
      + '?u=' + encodeURIComponent(window.location.origin + this.router.url)
    );
  }

  /*******************************************************************************
    설  명 : 트위터 게시글 공유
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  twitterShare() {
    window.open('https://twitter.com/intent/tweet'
      + '?text=' + encodeURIComponent(this.data.detail.subject)
      + '&url=' + encodeURIComponent(window.location.origin + this.router.url)
    );
  }
}
